import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Bannière urgente fixe - Réforme fiscale 2028
 * Affichée sur toutes les pages (sauf admin)
 * Peut être fermée par l'utilisateur (stocké dans localStorage)
 */
const UrgentBanner = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = React.useState(true);
  
  React.useEffect(() => {
    const bannerClosed = localStorage.getItem('urgentBannerClosed');
    if (bannerClosed === 'true') {
      setIsVisible(false);
    }
  }, []);
  
  const handleClose = () => {
    localStorage.setItem('urgentBannerClosed', 'true');
    setIsVisible(false);
  };
  
  if (!isVisible) return null;
  
  return (
    <div className="bg-red-700 text-white py-2 sm:py-3 px-3 sm:px-4 relative z-50">
      <div className="max-w-7xl mx-auto">
        {/* Mobile (< 640px) - Optimisé 360px */}
        <div className="sm:hidden">
          <div className="flex items-start gap-2 mb-2">
            <AlertTriangle className="w-4 h-4 flex-shrink-0 animate-pulse mt-0.5" />
            <p className="text-[11px] font-medium leading-tight flex-1 pr-1">
              <strong className="block mb-0.5">Réforme fiscale votée :</strong>
              <span className="text-[10px]">les déductions sur rénovations vont disparaître (2028)</span>
            </p>
            <button
              onClick={handleClose}
              className="text-white/80 hover:text-white p-0.5 flex-shrink-0"
              aria-label="Fermer"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          <Button
            onClick={() => navigate('/simulateur')}
            size="sm"
            className="bg-white text-red-700 hover:bg-slate-100 font-bold w-full text-xs py-2"
          >
            Simuler mes économies
          </Button>
        </div>
        
        {/* Desktop (>= 640px) */}
        <div className="hidden sm:flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <AlertTriangle className="w-5 h-5 flex-shrink-0 animate-pulse" />
            <p className="text-sm sm:text-base font-medium leading-tight truncate">
              <strong>Réforme fiscale votée en Suisse :</strong> les déductions sur les rénovations vont disparaître (entrée estimée 2028)
            </p>
          </div>
          
          <div className="flex items-center gap-3 flex-shrink-0">
            <Button
              onClick={() => navigate('/simulateur')}
              size="sm"
              className="bg-white text-red-700 hover:bg-slate-100 font-bold whitespace-nowrap"
            >
              Simuler mes économies
            </Button>
            
            <button
              onClick={handleClose}
              className="text-white/80 hover:text-white transition-colors p-1"
              aria-label="Fermer"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UrgentBanner;
